import {Component, DataForm} from 'argo-js/src/view';
import {Utils} from 'argo-js/src/common/Utils';

const ENABLE_PARAM = 'aid';
const RESET_PARAM = 'pid';

export class EnableAccount extends Component {

  constructor(config) {
    super({
      ui: {
        loading: '.js-loading',
        success: '.status-success',
        error: '.status-error',
        errorText: '.error-text',
        form: 'form',
        container: '.js-change-password'
      }
    }, config);
  }

  onInit() {

    let query = Utils.getQueryParams();
    this.token = query[ENABLE_PARAM] || query[RESET_PARAM] || null;
    if (!this.token) {
      this.showError();
    }
    this.shouldAccept = !!query[ENABLE_PARAM];

    this._form = new DataForm({
      app: this.app,
      el: this.ui.form,
      methods: {
        onSubmit: this.handlePwReset.bind(this)
      },
      errorMap: {
        NOT_FOUND: {
          message: 'pwreset.error.token'
        },
        PASSWORD_DOES_NOT_MATCH_RULES: {
          name: 'password',
          message: 'error.PASSWORD_DOES_NOT_MATCH_RULES'
        },
        NO_SUCH_USERNAME_OR_EMAIL: {
          name: 'email',
          message: 'pwreset.error.NO_SUCH_USERNAME_OR_EMAIL'
        },
        TERMS_AND_CONDITIONS_MUST_BE_ACCEPTED: {
          message: 'error.TERMS_AND_CONDITIONS_MUST_BE_ACCEPTED'
        },
      },
      on: {
        success: () => {
          this.ui.container.fadeOut(500);
          if (this.shouldAccept) {
            this.acceptTerms();
          }
          else {
            this.showSuccess();
          }
        }
      }
    });

    // user must be enabled by sending accept request
    this.shouldAccept ? this.acceptTerms() : this.showChangePw();
  }

  acceptTerms() {
    this.ui.loading.show();
    this.ui.container.hide();
    this.app.user
      .acceptTerms(this.token)
      .then(() => {
        this.showSuccess();
      })
      .catch(this.handleError.bind(this));
  }

  showChangePw() {
    this.ui.loading.hide();
    this.ui.container.fadeIn(500);
  }

  handleError(resp) {
    // special case -> mustChangePassword is enabled
    if (resp.errCode === 'CREDENTIALSEXPIRED') {
      this.ui.loading.hide();
      this.ui.container.fadeIn(500);
      return;
    }

    let message = resp.message;
    if (resp.status === 404) {
      message = this.t('activate.tokenNotFound');
    }

    if (resp.errCode && this.hasText(`error.${resp.errCode}`)) {
      message = this.t(`error.${resp.errCode}`);
    }

    this.showError(message);
  }

  showError(msg = null) {
    if (msg) {
      this.ui.errorText.text(msg);
    }
    this.ui.loading.hide();
    this.ui.error.fadeIn(500);
  }

  showSuccess() {
    this.ui.loading.hide();
    this.ui.success.fadeIn(500);

    setTimeout(() => {
      this.app.toHome();
    }, 1000);
  }

  handlePwReset(data) {
    return this.app.user.changePasswordByToken(this.token, data.password);
  }

}